
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_8j3to_3",
  "disabled": "awsui_disabled_93a1u_8j3to_12",
  "last": "awsui_last_93a1u_8j3to_18",
  "highlighted": "awsui_highlighted_93a1u_8j3to_21",
  "variant-navigation": "awsui_variant-navigation_93a1u_8j3to_26",
  "first": "awsui_first_93a1u_8j3to_37",
  "has-category-header": "awsui_has-category-header_93a1u_8j3to_37",
  "item-element-inner": "awsui_item-element-inner_93a1u_8j3to_51",
  "item-link": "awsui_item-link_93a1u_8j3to_68",
  "icon": "awsui_icon_93a1u_8j3to_74"
};
  